module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reset":"초기화","confirm":"적용"}}')
  delete Component.options._Ctor
}
